import { useEffect, useMemo } from 'react';
import { AnimationClip, Object3D } from 'three';
import { AvatarAnimator } from './animation';

/** No implicit useFrame update: the caller owns animation cadence and pose layering. */
export function useAvatarAnimator(clips: AnimationClip[], root: Object3D) {
  const animator = useMemo(() => new AvatarAnimator(root, clips), [root, clips]);
  useEffect(() => () => animator.stop(), [animator]);
  return animator;
}
